import type { AuthUser } from './AuthService'

export interface Auth0Claims {
  'x-hasura-auth0-user-id': string
  'x-hasura-email': string
  'x-hasura-title': string
  'x-hasura-locale': string
  'x-hasura-aptsnap-user-id': string
  'x-hasura-ownership-group-id': string
}

export interface Auth0Response {
  email: string
  email_verified: boolean
  name: string
  nickname: string
  picture: string
  'https://hasura.io/jwt/claims': Auth0Claims
}

export const fromAuth0 = {
  user: (u: Auth0Response = {} as Auth0Response) => {
    const user = {
      email: u.email,
      emailVerified: u.email_verified,
      name: u.name,
      nickname: u.nickname,
      picture: u.picture,
    } as AuthUser

    // Make the custom Hasura claims more easily available on the user object.
    const claims = u['https://hasura.io/jwt/claims']
    if (claims) {
      user.id = claims['x-hasura-aptsnap-user-id']
      user.title = claims['x-hasura-title']
      user.locale = claims['x-hasura-locale']
      user.ownershipGroupId = claims['x-hasura-ownership-group-id']
    }

    return user as AuthUser
  },
}
